import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ControlPanelComponent } from 'src/app/shared/modals/base-modal/control-panel/control-panel.component';



@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.less']
})
export class NavbarComponent implements OnInit {

  constructor(private ngbModal: NgbModal) { }

  ngOnInit() {
  }

  public activateControlPanel() {
    this.ngbModal.open(ControlPanelComponent, {
      size: 'lg'
    });
  }

}
